import React from 'react';

import Cookies from 'js-cookie';

import { MainModalController, Modal, ModalCloseButton } from '@uikit/components/Modal';
import ModalContent from '@uikit/components/Modal/ModalContent';
import ModalDescription from '@uikit/components/Modal/ModalDescription';
import ModalHeading from '@uikit/components/Modal/ModalHeading';

import storageKeys from '@shared/constants/storageKeys';

interface OneInchTermsModalProps {
  modalController: MainModalController;
}

export const OneInchTermsModal = ({ modalController }: OneInchTermsModalProps) => {
  const confirm = async () => {
    Cookies.set(storageKeys.SELF_SWAP_TERMS_AGREEMENT, 'y');
    modalController.close();
  };

  return (
    <Modal {...modalController.props}>
      <ModalContent className="max-w-[470px] py-[24px] px-[48px]">
        <ModalCloseButton className="mb-4" />

        <ModalHeading className="mb-4">Swap Service Disclaimer</ModalHeading>

        <ModalDescription className="m-0 text-xs text-neutral-700 font-light text-left">
          Before engaging with the swap feature on Magic Store, please understand that this feature
          is powered by the software developed by 1inch Limited (1inch Labs). Users are solely
          responsible for any issues that may arise from using this service, including but not
          limited to transaction failures, slippage, or unexpected fees. By proceeding and
          confirming your agreement via the checkbox below, you acknowledge your understanding of
          these aspects surrounding the provision and support of the swap service.
        </ModalDescription>

        <button className="w-full button button-lg button-primary mt-8" onClick={confirm}>
          I Understand and Confirm
        </button>
      </ModalContent>
    </Modal>
  );
};
